import React, { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faFaceSadTear } from "@fortawesome/free-regular-svg-icons";

import NavBar from "../components/common/navBar";

import { Link } from "react-router-dom";
import { useI18n, usePortfolioData } from "../i18n";

import styles from "./styles/404.module.css";

const Notfound = () => {
  const { t, localizedPath } = useI18n();
  const { user: INFO } = usePortfolioData();
  useEffect(() => {
    document.title = `404 | ${INFO.main.title}`;
  }, [INFO.main.title]);

  return (
    <React.Fragment>
      <div className={[styles["not-found"], "page-content"].join(" ")}>
        <NavBar />
        <div className="content-wrapper">
          <div className={styles["notfound-container"]}>
            <div className={styles["notfound-message"]}>
              <div className={styles["notfound-title"]}>
                {t("notFoundTitle")} <FontAwesomeIcon icon={faFaceSadTear} />
              </div>
              <div className={styles["not-found-message"]}>{t("notFound")}</div>
              <Link
                to={localizedPath("/")}
                className={styles["not-found-link"]}
              >
                {t("backHome")}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Notfound;
